export const PRONTLIFE_WHATSAPP_NUMBER = "5511989279101";
export const PRONTLIFE_EMAIL = "contato@prontlife.com.br";
